export const RoutePaths = {
    Dashboard: '/dashboard',
    Login: '/',
    PageNotFound: '*',
    FileManager: '/file-manager',
    SwitchPage: '/'
};
